import React, { Component } from 'react';
import { Navbar, Nav, Container, Jumbotron, Row, Col, Button } from 'react-bootstrap';

import { withRouter } from './withRouter.js';
import Syllabus from './Syllabus.js';
import People from './People.js';
import Policies from './Policies.js';
import Previous from './Previous.js';

import { acknowledgement, course_full_name, course_location, semester, course_number, course_objective, course_objective_long, course_short_name, course_sub_name, course_time } from './config.js';
import Howitworks from './Howitwork.js';


import { format } from 'date-fns';
import { Prev } from 'react-bootstrap/esm/PageItem.js';
class Home extends Component {

    scrollToSection = (e, sectionId) => {
        e.preventDefault();
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    render() {
        return (
            <>  <div id='header'> <figcaption>figure: https://d3js.org/</figcaption></div>
                  {/* <Container className='notification'> 
                    📢  Our  <a  href="/CMSC471-Spring25/#/gallery" target="_blank">  final project gallery </a> is live! Come explore 26 amazing interactive visualization projects built by students.
                </Container> */}
                <Navbar bg="white" expand="lg">
                    <Container className="mt-1">
                        <Navbar.Brand href="#">{course_number}</Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ml-auto">
                                <Nav.Link href="#" onClick={this.scrollToTop}>Home</Nav.Link>
                                <Nav.Link href="#howitworks" onClick={(e) => this.scrollToSection(e, 'howitworks')}>HTW</Nav.Link>
                                <Nav.Link href="#syllabus" onClick={(e) => this.scrollToSection(e, 'syllabus')}>Syllabus</Nav.Link>
                                <Nav.Link href="#crew" onClick={(e) => this.scrollToSection(e, 'crew')}>Crew</Nav.Link>
                                <Nav.Link href="#policies" onClick={(e) => this.scrollToSection(e, 'policies')}>Policies</Nav.Link>
                                <Nav.Link href="#previous" onClick={(e) => this.scrollToSection(e, 'previous')}>Previous</Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>

                <Container className='notification'> 
                    🎉  Our  <a  href="/CMSC471/#/gallery" target="_blank">  2026 final project gallery </a> is live! Come explore 23 amazing visualization projects built by students.
                    {/* Our  <a  href="/CMSC471/#/gallery" target="_blank">  2026 final project gallery </a> is live! Come explore 23 amazing interactive visualization projects built by students. */}
                </Container>

                <Container className="" style={{ 'top': 0, 'postiion': 'absolute' }}>
                    <div className="text-left">
                        <h1 className="display-4">{course_full_name}</h1>
                        <p className="lead">{course_sub_name}</p>

                        <h6> Time: <span className='color'>{course_time}</span> | Location: <span className='color'>{course_location}</span> | Semester: <span className='color'>{semester}</span> </h6>
                        <p> Last update: {format(new Date(document.lastModified), 'MM/dd/yyyy kk:mm')}
                        </p>
                    </div>

                    {/* <div className='check-back'>We are working on this web. So the content is not finalized yet.</div> */}
                    {/* <Row className='desktop-only' >
                            <Col lg={4}><img src={forecasts2020} className='headimage'></img> <figcaption>https://projects.fivethirtyeight.com/2020-election-forecast/</figcaption> </Col>
                            <Col lg={4}><img src={ggdist} className='headimage'></img> <figcaption>https://mjskay.github.io/ggdist/</figcaption> </Col>
                            <Col lg={4}><img src={llm} className='headimage'></img><figcaption>https://analyticsindiamag.com/ai-origins-evolution/the-rise-of-lame-llm-papers/</figcaption> </Col>

                        </Row> */}



                    <p dangerouslySetInnerHTML={{ __html: course_objective_long }}></p>
                    {/* <p dangerouslySetInnerHTML={{__html:course_objective}}></p> */}


                    <b>Useful links</b>: <a href="https://umd.instructure.com/courses/1398649" className='button-detail2' target='_blank'>Canvas</a>  <span className='piazza-note-wrapper'><a href="https://piazza.com/umd/spring2026/cmsc471" className='button-detail2' target='_blank'>Piazza</a> </span>


                    <hr className="my-4" />
                    <Howitworks />

                    <Syllabus />

                  

                    <Policies />

                      <People />

                    <Previous />

                    <>
                        <h2 id='policies'>Acknowledgements</h2>
                        <p dangerouslySetInnerHTML={{ __html: acknowledgement }}></p>
                    </>

                    {/* </div> */}


                </Container>

                {/* </div> */}
                <footer className="footer mt-auto py-3 bg-light">
                    <Container className="text-center">
                        <span className="text-muted">© 2024 University of Maryland, College Park.</span>
                    </Container>
                </footer>
            </>
        )
    }
}



export default withRouter(Home);